(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-privacy-info-bar"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('td-privacy-info-bar')) return;

  class TdPrivacyInfoBar extends HTMLElement {
    static get storageKey() {
      return 'td-privacy-dismissed';
    }

    static get customerPrivacyLoadTimeout() {
      return 2000;
    }

    static parseTargetList(str) {
      if (!str || typeof str !== 'string') return [];
      return str
        .split(',')
        .map((item) => item.trim().toUpperCase())
        .filter(Boolean);
    }

    static loadCustomerPrivacyApi() {
      const shopify = window.Shopify;
      if (!shopify) return Promise.resolve(null);

      if (shopify.customerPrivacy && typeof shopify.customerPrivacy.getRegion === 'function') {
        return Promise.resolve(shopify.customerPrivacy);
      }

      if (typeof shopify.loadFeatures !== 'function') return Promise.resolve(null);

      return new Promise((resolve) => {
        let settled = false;

        const finalize = (api) => {
          if (settled) return;
          settled = true;
          window.clearTimeout(timeoutId);
          resolve(api || null);
        };

        const timeoutId = window.setTimeout(() => {
          finalize(shopify.customerPrivacy || null);
        }, TdPrivacyInfoBar.customerPrivacyLoadTimeout);

        shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
          if (error) {
            console.error('Failed to load Shopify Customer Privacy API:', error);
            finalize(null);
            return;
          }

          finalize(shopify.customerPrivacy || null);
        });
      });
    }

    static async checkGeoMatch(targetUsStates, targetCaProvinces) {
      const usStates = TdPrivacyInfoBar.parseTargetList(targetUsStates);
      const caProvinces = TdPrivacyInfoBar.parseTargetList(targetCaProvinces);

      if (usStates.length === 0 && caProvinces.length === 0) return false;

      const customerPrivacy = await TdPrivacyInfoBar.loadCustomerPrivacyApi();
      if (!customerPrivacy || typeof customerPrivacy.getRegion !== 'function') return false;

      try {
        const regionCode = String(customerPrivacy.getRegion() || '').trim().toUpperCase();
        if (regionCode.length < 4) return false;

        const country = regionCode.slice(0, 2);
        const region = regionCode.slice(2);

        if (country === 'US' && usStates.length > 0) {
          return usStates.includes(region);
        }

        if (country === 'CA' && caProvinces.length > 0) {
          return caProvinces.includes(region);
        }

        return false;
      } catch (error) {
        console.error('Privacy bar region check failed:', error);
        return false;
      }
    }

    static isDismissed(expiryDays) {
      try {
        const dismissedData = localStorage.getItem(TdPrivacyInfoBar.storageKey);
        if (!dismissedData) return false;

        const { expiry } = JSON.parse(dismissedData);
        if (Date.now() < expiry) {
          return true;
        }

        localStorage.removeItem(TdPrivacyInfoBar.storageKey);
        return false;
      } catch (error) {
        console.error('Error checking privacy dismissal:', error);
        return false;
      }
    }

    static setDismissed(expiryDays) {
      try {
        const expiry = Date.now() + expiryDays * 24 * 60 * 60 * 1000;
        localStorage.setItem(TdPrivacyInfoBar.storageKey, JSON.stringify({ expiry }));
      } catch (error) {
        console.error('Error setting privacy dismissal:', error);
      }
    }

    connectedCallback() {
      this.expiryDays = parseInt(this.dataset.expiryDays, 10) || 30;
      this.acceptBtn = this.querySelector('[data-privacy-accept]');
      this.closeBtn = this.querySelector('[data-privacy-close]');

      this.init();
      this.setupEventListeners();
      this.setupDesignMode();
    }

    async init() {
      const shopify = window.Shopify || {};

      if (shopify.designMode) {
        this.show();
        return;
      }

      if (TdPrivacyInfoBar.isDismissed(this.expiryDays)) return;

      const matches = await TdPrivacyInfoBar.checkGeoMatch(
        this.dataset.targetUsStates || '',
        this.dataset.targetCaProvinces || ''
      );

      if (matches) this.show();
    }

    setupEventListeners() {
      if (this.acceptBtn) {
        this.acceptBtn.addEventListener('click', () => this.dismiss());
      }

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.dismiss());
      }
    }

    setupDesignMode() {
      const shopify = window.Shopify || {};
      if (!shopify.designMode) return;

      document.addEventListener('shopify:section:select', (evt) => {
        if (evt.target === this.closest('.shopify-section')) {
          this.show();
        }
      });

      document.addEventListener('shopify:section:deselect', (evt) => {
        if (evt.target === this.closest('.shopify-section')) {
          this.hide();
        }
      });
    }

    show() {
      this.classList.remove('td-privacy-info-bar--hidden');
    }

    hide() {
      this.classList.add('td-privacy-info-bar--hidden');
    }

    dismiss() {
      const shopify = window.Shopify || {};
      if (!shopify.designMode) {
        TdPrivacyInfoBar.setDismissed(this.expiryDays);
      }
      this.hide();
    }
  }

  customElements.define('td-privacy-info-bar', TdPrivacyInfoBar);
})();

  } catch(e) { console.error(e); }
})();
})();
